<template>
  <div class="layout-center-wrap">
    <!-- 회원가입 상단 헤더 -->
    <header class="member_pg_tit__wrap">
      <h1 class="member_pg_tit">보호자 동의 및 본인 인증</h1>
    </header>
    <br />
    <table class="board-write type-block--mobile">
      <tbody>
        <tr>
          <th scope="row">
            이름<span class="svg_icon icon_must" aria-hidden="true"></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="name" class="sr-only">이름 입력</label>
            <input
              type="text"
              id="name"
              class="board-write__input"
              placeholder="만 14세 미만 아동의 이름을 입력하십시오"
              v-model="memberInfo.childName"
            />
          </td>
        </tr>
        <tr>
          <th scope="row">
            휴대전화 번호<span
              class="svg_icon icon_must"
              aria-hidden="true"
            ></span
            ><span class="sr-only">필수입력</span>
          </th>
          <td>
            <label for="tel" class="sr-only">휴대전화 번호 입력</label>
            <input
              type="text"
              id="tel"
              class="board-write__input"
              placeholder="만 14세 미만 아동의 휴대전화 번호를 입력하십시오."
              v-model="memberInfo.childPhone"
            />
          </td>
        </tr>
      </tbody>
    </table>
    <NicePopup
      class="btn__wrap type-bottom-board"
      v-on:success="goToChildPage"
      type="CHILD-REPORT"
      title="보호자 인증하기"
      :childName="memberInfo.childName"
      :childPhone="memberInfo.childPhone"
    />
  </div>
</template>

<script>
import { useRouter, useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import NicePopup from "./NicePopup.vue";
import dc from "@/component/DataChk.js";

export default {
  components: {
    NicePopup,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();

    // data 정의
    const memberInfo = ref({ childName: "", childPhone: "" });

    // methods 정의
    const goToChildPage = (refId) => {
      if (!dc.nullChk(refId)) {
        alert("잘못된 접근입니다.\n초기 페이지로 이동합니다.");
        router.push("/");
        return;
      }
      router.push({
        name: "joinReporter",
        query: {
          refId: refId,
          hasChild: route.query.hasChild,
        },
      });
    };

    // life cycle 정의
    onMounted(() => {
      if (!route.query.hasChild) {
        router.push("/");
        return;
      }
    });

    // html에서 사용될 데이터 정의
    return {
      goToChildPage,
      memberInfo,
    };
  },
};
</script>
<style>
</style>